module.exports = __webpack_public_path__ + "img/blue_116.d0c4d7b2.png";